import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "row auto-kitchen" };
const _hoisted_2 = { class: "col-lg-12" };
const _hoisted_3 = { class: "collection-list__inline" };
const _hoisted_4 = {
    key: 0,
    class: "spinner-border text-primary",
    role: "status"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "collection-name" };
const _hoisted_7 = { class: "catalog-name" };
const _hoisted_8 = { class: "col-lg-12" };
const _hoisted_9 = { class: "style-list" };
const _hoisted_10 = { class: "card-body min-body collection" };
const _hoisted_11 = {
    key: 0,
    class: "tab-content"
};
const _hoisted_12 = { class: "tab-pane active" };
const _hoisted_13 = {
    key: 0,
    class: "table"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "style-layout" };
const _hoisted_16 = { class: "title" };
const _hoisted_17 = { class: "description" };
const _hoisted_18 = { style: { "width": "100px" } };
const _hoisted_19 = { class: "style-detail" };
const _hoisted_20 = { class: "title-layout d-flex mt-2" };
const _hoisted_21 = { class: "tab-content style-detail-layout mt-3" };
const _hoisted_22 = { class: "tab-pane active" };
const _hoisted_23 = { class: "row" };
const _hoisted_24 = { class: "col-lg-12" };
const _hoisted_25 = { class: "form-group" };
const _hoisted_26 = { class: "col-lg-12" };
const _hoisted_27 = { class: "form-group" };
const _hoisted_28 = { class: "col-lg-12" };
const _hoisted_29 = { class: "form-group" };
const _hoisted_30 = { class: "col-lg-12 image-layout" };
const _hoisted_31 = { class: "form-group" };
const _hoisted_32 = {
    class: "d-flex mt-2",
    style: { "gap": "20px" }
};
const _hoisted_33 = { class: "info-block" };
const _hoisted_34 = { key: 0 };
const _hoisted_35 = { class: "file-name" };
const _hoisted_36 = { class: "file-size" };
const _hoisted_37 = { class: "btn btn-simple no-border" };
import { onMounted, ref } from "vue";
import "/src/styles/autokitchen.css";
import AutoKitchen from "@/module/AutoKitchen";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CollectionView',
    setup(__props) {
        const collections = ref(null);
        const activeCollection = ref({ id: 0, styles: [] });
        const activeStyle = ref({ id: 0 });
        const selectedFile = ref(null);
        const onFileChange = (event) => {
            const target = event.target;
            const file = target.files?.[0];
            if (!file)
                return;
            selectedFile.value = file;
            activeStyle.value.image = URL.createObjectURL(file);
        };
        const changeStyle = () => {
            AutoKitchen.updateStyle(activeStyle.value, selectedFile.value).then((res) => {
                activeCollection.value.styles.forEach((style, i) => {
                    if (style.id == activeStyle.value.id) {
                        activeCollection.value.styles[i] = res.getResponse().data;
                    }
                });
                activeStyle.value = { id: 0 };
            });
        };
        const readableSize = (size) => {
            return (size / 1024).toFixed(0) + " КБ";
        };
        onMounted(() => {
            AutoKitchen.getCollections().then((res) => {
                if (res && res.isSuccess()) {
                    collections.value = res.getResponse();
                    if (res.getResponse().length > 0) {
                        activeCollection.value = collections.value[0];
                    }
                }
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "collection-tab create" }, "Создать новую коллекцию", -1)),
                        (collections.value === null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[3] || (_cache[3] = [
                                _createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
                            ])))
                            : (collections.value.length > 0)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(collections.value, (collection) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: collection.id,
                                        class: _normalizeClass(["collection-tab", { active: collection.id === activeCollection.value.id }]),
                                        onClick: _withModifiers(($event) => {
                                            activeCollection.value = collection;
                                            activeStyle.value = { id: 0 };
                                        }, ["prevent"])
                                    }, [
                                        _createElementVNode("span", _hoisted_6, _toDisplayString(collection.name), 1),
                                        _createElementVNode("span", _hoisted_7, _toDisplayString(collection?.catalog.name), 1)
                                    ], 10, _hoisted_5));
                                }), 128))
                                : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["card", { 'active-style': activeStyle.value.id > 0 }])
                    }, [
                        _createElementVNode("div", _hoisted_9, [
                            _cache[8] || (_cache[8] = _createStaticVNode("<ul class=\"nav nav-tabs collection-content-tabs\"><li class=\"nav-item\"><a class=\"nav-link disabled\"> Модули </a></li><li class=\"nav-item\"><a class=\"nav-link active\"> Стили </a></li><li class=\"nav-item\"><a class=\"nav-link disabled\"> Наполнение </a></li><li class=\"nav-item\"><a class=\"nav-link disabled\"> Ценовые группы </a></li><li class=\"nav-item\"><a class=\"nav-link disabled\"> Фурнитуры </a></li></ul>", 1)),
                            _createElementVNode("div", _hoisted_10, [
                                (activeCollection.value.id > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, [
                                            (activeCollection.value.styles.length > 0)
                                                ? (_openBlock(), _createElementBlock("table", _hoisted_13, [
                                                    _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                                                        _createElementVNode("tr", null, [
                                                            _createElementVNode("th", null, "Название стиля"),
                                                            _createElementVNode("th", null, "Создано"),
                                                            _createElementVNode("th", null, "Цена"),
                                                            _createElementVNode("th", null, "Статус"),
                                                            _createElementVNode("th")
                                                        ])
                                                    ], -1)),
                                                    _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeCollection.value.styles, (style) => {
                                                            return (_openBlock(), _createElementBlock("tr", {
                                                                key: style.id,
                                                                onClick: _withModifiers(($event) => {
                                                                    activeStyle.value = JSON.parse(JSON.stringify(style));
                                                                    selectedFile.value = null;
                                                                }, ["prevent"]),
                                                                class: _normalizeClass(["style", { active: activeStyle.value.id == style.id }])
                                                            }, [
                                                                _createElementVNode("td", null, [
                                                                    _createElementVNode("div", _hoisted_15, [
                                                                        _createElementVNode("div", {
                                                                            class: "image",
                                                                            style: _normalizeStyle(`background-image: url(${style.image})`)
                                                                        }, null, 4),
                                                                        _createElementVNode("div", null, [
                                                                            _createElementVNode("div", _hoisted_16, _toDisplayString(style.title), 1),
                                                                            _createElementVNode("div", _hoisted_17, _toDisplayString(style.description), 1)
                                                                        ])
                                                                    ])
                                                                ]),
                                                                _createElementVNode("td", _hoisted_18, _toDisplayString(style.createdAt), 1),
                                                                _createElementVNode("td", null, "от " + _toDisplayString(style.price) + " Р/м.п.", 1),
                                                                _cache[5] || (_cache[5] = _createElementVNode("td", null, null, -1)),
                                                                _cache[6] || (_cache[6] = _createElementVNode("td", null, null, -1))
                                                            ], 10, _hoisted_14));
                                                        }), 128))
                                                    ])
                                                ]))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createTextVNode("У вас пока нет стилей в коллекции")
                                                ], 64))
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_19, [
                            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "style-navbar-layout mt-2" }, null, -1)),
                            _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("h3", null, _toDisplayString(activeStyle.value.title), 1)
                                ]),
                                _createElementVNode("div", null, [
                                    _createElementVNode("button", {
                                        class: "btn btn-simple",
                                        onClick: _withModifiers(changeStyle, ["prevent"])
                                    }, " Сохранить изменения ")
                                ])
                            ]),
                            _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"style-tabs mt-2\"><ul class=\"nav nav-tabs collection-content-tabs\"><li class=\"nav-item\"><a class=\"nav-link active\"> Общие </a></li><li class=\"nav-item\"><a class=\"nav-link disabled\"> Вариантные свойства </a></li><li class=\"nav-item\"><a class=\"nav-link disabled\"> Параметры </a></li><li class=\"nav-item\"><a class=\"nav-link disabled\"> Элементы </a></li></ul></div>", 1)),
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, [
                                        _createElementVNode("div", _hoisted_24, [
                                            _createElementVNode("div", _hoisted_25, [
                                                _cache[9] || (_cache[9] = _createElementVNode("span", null, " Название стиля ", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    name: "title",
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((activeStyle.value.title) = $event)),
                                                    class: "form-control"
                                                }, null, 512), [
                                                    [_vModelText, activeStyle.value.title]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_26, [
                                            _createElementVNode("div", _hoisted_27, [
                                                _cache[10] || (_cache[10] = _createElementVNode("span", null, " Описание стиля ", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    name: "title",
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((activeStyle.value.description) = $event)),
                                                    class: "form-control"
                                                }, null, 512), [
                                                    [_vModelText, activeStyle.value.description]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_28, [
                                            _createElementVNode("div", _hoisted_29, [
                                                _cache[11] || (_cache[11] = _createElementVNode("span", null, " Цена ", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    name: "title",
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((activeStyle.value.price) = $event)),
                                                    class: "form-control"
                                                }, null, 512), [
                                                    [_vModelText, activeStyle.value.price]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_30, [
                                            _createElementVNode("div", _hoisted_31, [
                                                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "label" }, "Изображение модели", -1)),
                                                _createElementVNode("div", _hoisted_32, [
                                                    _createElementVNode("div", {
                                                        class: "image",
                                                        style: _normalizeStyle({
                                                            backgroundImage: activeStyle.value.image
                                                                ? `url(${activeStyle.value.image})`
                                                                : '',
                                                        })
                                                    }, null, 4),
                                                    _createElementVNode("div", _hoisted_33, [
                                                        (selectedFile.value !== null)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                                _createElementVNode("div", _hoisted_35, _toDisplayString(selectedFile.value.name), 1),
                                                                _createElementVNode("div", _hoisted_36, _toDisplayString(readableSize(selectedFile.value.size)), 1)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        _createElementVNode("label", _hoisted_37, [
                                                            _cache[12] || (_cache[12] = _createTextVNode(" Изменить изображение ")),
                                                            _createElementVNode("input", {
                                                                type: "file",
                                                                onChange: onFileChange,
                                                                accept: "image/*",
                                                                hidden: ""
                                                            }, null, 32)
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ], 512), [
                            [_vShow, activeStyle.value.id > 0]
                        ])
                    ], 2)
                ])
            ]));
        };
    }
});
